import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { get_grid2d_key } from '@/utils/utils_grid2d';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__grid2d_get_by_entity_type_and_id } from '@shared/dto/grid2d/_requests/DTO_REQUEST__grid2d_get_by_entity_type_and_id';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__grid2d } from '../STATE__grid2d';

export const REMOTE__grid2d_get_by_entity_type_and_id = createAsyncThunkSafe<
  DTO_REQUEST__grid2d_get_by_entity_type_and_id[],
  DTO_REQUEST__grid2d_get_by_entity_type_and_id[]
>(ENUM__network_event_client_to_server.GRID2D_GET_BY_ENTITY_TYPE_AND_ID, async (requests: DTO_REQUEST__grid2d_get_by_entity_type_and_id[]) => {
  await send_to_server(ENUM__network_event_client_to_server.GRID2D_GET_BY_ENTITY_TYPE_AND_ID, requests);

  return requests;
});

export function INIT_REMOTE__grid2d_get_by_entity_type_and_id(builder: ActionReducerMapBuilder<STATE__grid2d>) {
  builder
    .addCase(REMOTE__grid2d_get_by_entity_type_and_id.pending, (state, action) => {
      for (let request of action.meta.arg) {
        let key = get_grid2d_key(request.entity_type, request.entity_id);

        state.grid2d_loading_in_progress.add(key);

        //need to force rerender
        state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
      }
    })
    .addCase(REMOTE__grid2d_get_by_entity_type_and_id.rejected, (state, action) => {})
    .addCase(REMOTE__grid2d_get_by_entity_type_and_id.fulfilled, (state, action: PayloadAction<DTO_REQUEST__grid2d_get_by_entity_type_and_id[]>) => {
      for (let request of action.payload) {
        let key = get_grid2d_key(request.entity_type, request.entity_id);

        state.grid2d_loading_in_progress.delete(key);

        //need to force rerender
        state.grid2d_loading_in_progress = new Set(state.grid2d_loading_in_progress);
      }
    });
}
